const initialState = {
  employees: { data: { data: [], pagination: {} } },
  employee: { data: null },
  employeeHistory: []
};

const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_EMPLOYEES':
      return {
        ...state,
        employees: {
          data: {
            employeeData: action.data.data.data,
            count: action.data.data.count,
            msg: action.data.msg
          }
        }
      };
      case 'GET_EMPLOYEE_BY_ID':
        return {
          ...state,
          employee: {
            data: action.data?.data || null
          }
        };
    case 'UPDATE_EMPLOYEE_BY_ADMIN':
      return {
        ...state,
        employee: { data: action.data }
      };
    case 'GET_EMPLOYEE_HISTORY':
      return {
        ...state,
        employeeHistory: action.data
      };
    default:
      return state;
  }
};

export default employeeReducer;
  